import React, { useContext, useState, useEffect } from 'react';
import { BookingFlowContext } from '../BookingFlowContext'
import { products } from '../Endpoints';

export const NearbyFacilities = () => {
  const { bookingFlowContext } = useContext(BookingFlowContext);
  const nearbyFacilities = bookingFlowContext.facility.nearbyFacilities;
  const [itemsToShow, setItemsToShow] = useState(nearbyFacilities?.length > 5 ? 5 : nearbyFacilities?.length);
  const currentFacility = bookingFlowContext.facility;
  const formLang = bookingFlowContext.localization.onlineBooking;
  const selectedLang = document.querySelector('html').getAttribute('lang');
  const selectedLocale = selectedLang === 'no' ? 'nb' : selectedLang === 'se' ? 'sv' : selectedLang;
  const [checkedFacilities, setCheckedFacilities] = useState([]);

  useEffect(() => {
    if (!nearbyFacilities?.length) return;

    let isSubscribed = true;
    let hasAvailableSpot = null;
    let hasLowAvailability = null;
    let hasPromotion = false;
    const facilities = [];

    const checkDetails = async (uid) => {
      const allProducts = await products.getProducts({ bookingController: bookingFlowContext.episerver.bookingController, fId: uid, lang: selectedLocale, includeNotBookableOnline: true });
      if (allProducts.status === 200 && allProducts.body.Places.length > 0) {
        const listOfProducts = allProducts.body.Places.map(zone => zone.Item2).flat();
        const isBookableOnline = listOfProducts.some(product => !product.OnlineBookingNotAllowed);
        hasPromotion = listOfProducts.some(product => Array.isArray(product.Promotions) && product.Promotions.length > 0);
        if (!bookingFlowContext.episerver.hideAvailability && isBookableOnline) {
          hasAvailableSpot = formLang.availability && listOfProducts.some(product => !product.OnlineBookingNotAllowed && product.Availability && product.Availability > 0);
          hasLowAvailability = formLang.availability && !listOfProducts.some(product => !product.OnlineBookingNotAllowed && product.Availability && product.Availability > 4);
        }
      }
      return { uid, hasPromotion, hasAvailableSpot, hasLowAvailability };
    }

    nearbyFacilities.slice(0, itemsToShow).forEach(facility => {
      if (checkedFacilities.find(f => f.uid === facility.Uid)) return;
      const icons = checkDetails(facility.Uid);
      facilities.push(icons);
    });

    Promise.all(facilities).then(icons => {
      if (!isSubscribed) return;
      setCheckedFacilities([...checkedFacilities, ...icons]);
    });
    return () => isSubscribed = false;
  }, [itemsToShow]);

  return nearbyFacilities?.length ? (
    <div className="bookingflowpage__nearby-facilities">
      <h3>{`${formLang.nearbyfacilities} ${currentFacility.name}`}</h3>
      <ul>
        <li>
          <span>{formLang.address}</span>
          <span>{`${formLang.distanceto} ${currentFacility.name}`}</span>
        </li>
        {nearbyFacilities.slice(0, itemsToShow).map(facility => <ListItem
          key={facility.Uid + itemsToShow}
          formLang={bookingFlowContext?.localization?.onlineBooking}
          distance={facility.Address.Distance}
          url={facility.Url}
          name={facility.Name}
          address={facility.Address}
          icons={checkedFacilities.length ? checkedFacilities.find(f => f.uid === facility.Uid) : null}
          selectedLocale={selectedLocale} />
        )}
      </ul>
      {(nearbyFacilities.length > 5 && nearbyFacilities.length !== itemsToShow) && <button onClick={() => setItemsToShow(itemsToShow + (nearbyFacilities.length - itemsToShow < 5 ? nearbyFacilities.length - itemsToShow : 5))} className="bookingflowpage__nearby-facilities__cta">
        <span>{formLang.showmore}</span>
      </button>}
    </div>
  ) : null;
}

const ListItem = ({ formLang, distance, url, name, address, selectedLocale, icons }) => {
  const currentDistance = distance > 1 ? distance.toFixed(2) : Math.round(distance * 1000);
  const currentDistanceText = distance > 1 ? 'km' : 'm';
  const hasPromotion = icons?.hasPromotion;
  const hasAvailableSpot = icons?.hasAvailableSpot;
  const hasLowAvailability = icons?.hasLowAvailability;
  const facilityAddress = address.Number ? `${address.Street} ${address.Number}` : address.Street;
  const facilityName = name === facilityAddress ? facilityAddress : name;

  return (
    <li>
      {hasPromotion ? <div className="left--promo">
        <div className="left">
          <a href={url} onClick={(e) => { if (!url) e.preventDefault() }}>{facilityName}</a>
          <div className="left--availablespot" data-low={hasLowAvailability}>{facilityAddress}{hasAvailableSpot && <div>{hasLowAvailability ? formLang.lowavailability : formLang.availability}</div>}</div>
        </div>
        <img src={`/publicResources/icons/promo/${selectedLocale}/Promotion2_${selectedLocale}.svg`} alt="promotion icon" />
      </div> :
        <div className="left"><a href={url} onClick={(e) => { if (!url) e.preventDefault() }}>{facilityName}</a><div className="left--availablespot" data-low={hasLowAvailability}>{facilityAddress}{hasAvailableSpot && <div>{hasLowAvailability ? formLang.lowavailability :formLang.availability}</div>}</div></div>}
      <div className="right"><span>{currentDistance} {currentDistanceText}</span></div>
    </li>
  )
}
